import Axios from '@/libs/services'

const Request = new Axios()

const service = ''
const version = 'v1'

class SettingsService {
  getMe = () => {
    const uri = 'me/'
    const service = 'accounts'

    return Request.get({ service, uri, version })
  }

  updateMe = body => {
    const uri = 'me/'
    const service = 'accounts'

    return Request.patch({ body, service, uri, version })
  }

  changePassword = (oldPassword, newPassword) => {
    const uri = 'password/'
    const service = 'accounts'

    return Request.post({ body: { oldPassword, newPassword }, service, uri, version })
  }

  getOrganization = () => {
    const service = 'organizations/'

    return Request.get({ service, version })
  }

  createOrganization = ({ body, logoFile }) => {
    const service = ''
    const uri = 'organizations/'

    return Request.post({
      body,
      files: { logo: logoFile },
      service,
      uri,
      version,
      skipSnakeCase: true,
    })
  }

  updateOrganization = (organizationId, body, logoFile) => {
    const service = ''
    const uri = `organizations/${organizationId}/`

    const req = { body, service, uri, version }

    if (logoFile) {
      req.files = { logo: logoFile }
    }

    return Request.put(req)
  }

  getTimezones = (search = '') => {
    const uri = `timezones/?q=${search}`
    return Request.get({ version: 'v2', service, uri })
  }

  getIndustries = () => {
    const uri = 'industries/'
    return Request.get({ version, service, uri })
  }

  getCountries = () => {
    const uri = 'countries/'
    return Request.get({ version, service, uri })
  }
}

export default new SettingsService()
